import { formatMessageForHumans } from "./formatters";
import type { Logger } from "./types";

/**
 * Client implements the Logger interface and is used for logging on a client. It differs from the Server logger in
 * that it will typically not dispatch a message to the remote logging service for analysis. Instead, it will
 * typically only emit messages when the client is in development mode.
 */
export class Client implements Logger {
  constructor(readonly instanceId: string) {}

  error(
    _errCode: string,
    _caller: string,
    message: string,
    error?: unknown,
    optionalParams?: Record<string, unknown>
  ): void {
    console.error(message, error, optionalParams);
  }

  info(caller: string, message: string, optionalParams?: Record<string, unknown>) {
    optionalParams
      ? console.info(formatMessageForHumans(false, this.instanceId, caller, message), optionalParams)
      : console.info(formatMessageForHumans(false, this.instanceId, caller, message));
  }

  warn(caller: string, message: string, optionalParams?: Record<string, unknown>) {
    optionalParams
      ? console.warn(formatMessageForHumans(false, this.instanceId, caller, message), optionalParams)
      : console.warn(formatMessageForHumans(false, this.instanceId, caller, message));
  }
}
